<template>
  <span
    class="inspection-level-badge"
    :class="badgeClass"
  >
    {{ levelLabel }}
  </span>
</template>

<script setup>
import { computed } from "vue";
import {
  getBadgeLevelDisplayLabel,
  isBadgeLevelValue,
  normalizeBadgeLevel,
} from "@components/utils/normalizeBadgeLevel";

const props = defineProps({
  /** Readiness level shown on the pill badge. */
  level: {
    type: String,
    default: "Apprentice",
    validator: (value) =>
      isBadgeLevelValue(value) && normalizeBadgeLevel(value) !== "novice",
  },
});

const levelLabel = computed(
  () => getBadgeLevelDisplayLabel(props.level) || props.level
);

const badgeClass = computed(
  () => `inspection-level-badge--${normalizeBadgeLevel(props.level) || props.level.toLowerCase()}`
);
</script>

<style scoped>
.inspection-level-badge {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  box-sizing: border-box;
  padding: 3px 12px;
  border: 1.5px solid;
  border-radius: 9999px;
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: normal;
  white-space: nowrap;
}

.inspection-level-badge--apprentice {
  background: #fff5d3;
  border-color: #e58700;
  color: #e58700;
}

.inspection-level-badge--proficient {
  background: #f3fff9;
  border-color: #00b813;
  color: #00b813;
}

.inspection-level-badge--coach {
  background: #effeff;
  border-color: #00a3ff;
  color: #00a3ff;
}

.inspection-level-badge--architect {
  background: #f2f3ff;
  border-color: #2e1ec1;
  color: #2e1ec1;
}
</style>
